<template>
  <div>
    <h2 class="font-nutino font-bold lg:font-extrabold text-[20px] lg:text-[48px] text-center">{{ t('b2b.wellbeing.hr-optimization.title') }}</h2>
    <p class="font-avenir text-[16px] md:text-[30px] mt-[24px] text-center leading-[1.4] opacity-60">{{ t('b2b.wellbeing.hr-optimization.subtitle') }}</p>
    <div class="flex flex-wrap lg:flex-nowrap justify-center gap-[12px] mt-[24px]">
      <Chip small black>
        {{ t('b2b.wellbeing.hr-optimization.chip.1') }}
      </Chip>
      <Chip small black>
        {{ t('b2b.wellbeing.hr-optimization.chip.2') }}
      </Chip>
      <Chip small black>
        {{ t('b2b.wellbeing.hr-optimization.chip.3') }}
      </Chip>
    </div>
    <div class="flex mt-[48px]">
      <Card shadow bgColor>
        <div class="py-[20px] px-[10px] md:py-[40px] flex flex-col items-center ">
          <h3 class="font-nutino text-[20px] lg:text-[40px]">{{ t('b2b.wellbeing.hr-optimization.advantages') }}</h3>
          <div class="flex flex-col gap-y-[12px] items-start md:items-center mt-[29px]">
            <span class="font-bold text-[16px] lg:text-[30px]">{{ t('b2b.wellbeing.hr-optimization.advantages.1') }}</span>
            <span class="font-bold text-[16px] lg:text-[30px]">{{ t('b2b.wellbeing.hr-optimization.advantages.2') }}</span>
            <span class="font-bold text-[16px] lg:text-[30px]">{{ t('b2b.wellbeing.hr-optimization.advantages.3') }}</span>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import Chip from '../ui/Chip.vue';
import Card from '../ui/Card.vue';

const { t } = useI18n();

</script>
